import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import { mapGetters } from 'vuex';
import store from '@/store';
import { getTagList } from '@/api/common/index.js';
import { searchUserList } from '@/api/system/user';
import { format, subDays } from 'date-fns';
import BasePackageTagSelector from '@/components/BasePackageTagSelector/index.vue';
import AppCategorySelector from '@/components/AppCategorySelector';
import DemandSelector from '../DemandSelector/index.vue';
import { testStatus } from '@/common/material-metadata';

export default {
  components: {
    BasePackageTagSelector: BasePackageTagSelector,
    AppCategorySelector: AppCategorySelector,
    DemandSelector: DemandSelector
  },
  computed: _extends({}, mapGetters(['category', 'material_options', 'user_id']), {
    searchFieldPlaceholder: {
      get: function get() {
        var self = this;
        if (self.aProp.aSearchField.length) {
          return self.aProp.aSearchField.find(function (e) {
            return e.id === self.searchField;
          }).name;
        }
        return '关键词';
      }
    }
  }),
  mounted: function mounted() {
    var self = this;
    if (!self.category.length) {
      store.dispatch('GetCategory').then(function (res) {
        self.categoryLoading = false;
      }).catch(function () {
        self.categoryLoading = false;
      });
    } else {
      self.categoryLoading = false;
    }

    if (self.aProp.materialOptions && !self.material_options.networks) {
      store.dispatch('GetMaterialOptions').then(function (res) {
        self.materialLoading = false;
      }).catch(function () {
        self.materialLoading = false;
      });
    }
    if (self.aProp.bModelStyle) {
      getTagList({
        type: 3
      }).then(function (res) {
        self.bStyleLoading = false;
        self.aModelStyleOptions = res.data.data.tags;
      }).catch(function () {});
    }

    // 自定义搜索选择项
    if (self.aProp.customSelector && self.aProp.customSelector.length > 0) {
      var _loop = function _loop(i) {
        var item = self.aProp.customSelector[i];
        self.$set(self.customSelector, item.selectorId, {});
        self.$set(self.customSelector[item.selectorId], 'value', item.multiple ? [] : '');
        self.$set(self.customSelector[item.selectorId], 'loading', true);
        if (!item.data) {
          getTagList({
            type: item.tagId
          }).then(function (res) {
            // self.bStyleLoading = false
            self.customSelector[item.selectorId].loading = false;
            self.$set(self.customSelector[item.selectorId], 'tags', res.data.data.tags);
          }).catch(function () {});
        } else {
          self.customSelector[item.selectorId].loading = false;
          self.$set(self.customSelector[item.selectorId], 'tags', item.data);
        }
      };

      for (var i in self.aProp.customSelector) {
        _loop(i);
      }
    }

    if (self.aProp.bModelAnimation) {
      getTagList({
        type: 2
      }).then(function (res) {
        self.bAnimationLoading = false;
        self.aModelAnimationOptions = res.data.data.tags;
      }).catch(function () {});
    }
    if (self.aProp.managerName) {
      searchUserList({
        data_perm: 'data.advertiser',
        page: 1,
        page_size: 400
      }).then(function (res) {
        var aTemp = [{ id: 0, real_name: 'All' }];
        self.managerNameOptions = aTemp.concat(res.data.data.list);
        // 更换接口，数据结构有变动，修改数据格式兼容老的数据格式
        self.managerNameOptions = self.managerNameOptions.map(function (item) {
          item.nickname = item.real_name;
          return item;
        });
        self.managerName = self.managerNameOptions.find(function (e) {
          return Number(e.id) === Number(self.user_id);
        }).id;
        self.handleFilter();
      }).catch(function () {
        self.managerNameOptions = [];
      });
    }
    if (self.$route.query.search_key) {
      self.searchField = self.$route.query.search_key;
      self.keyword = self.$route.query.search_value;
      self.handleFilter();
    }
    if (self.$route.query.mid) {
      self.keyword = self.$route.query.mid;
      self.time = [self.$route.query.date, self.$route.query.date];
      self.handleFilter();
    }
    this.fillDemandValue();
  },

  props: {
    fnSearch: {
      type: Function,
      default: false
    },
    aProp: {
      type: Object,
      default: false
    },
    trafficOptions: {
      type: Array,
      default: function _default() {
        return [{
          id: '1',
          name: 'M流量'
        }, {
          id: '2',
          name: 'DSP流量'
        }];
      }
    }
  },
  data: function data() {
    return {
      trafficType: '',
      managerName: '',
      managerNameOptions: [],
      networks: '',
      categories: '',
      genre: '',
      tags: '',
      materialLoading: true,
      platform: '',
      // app_cat_ids: [],
      level: '',
      bugstate: '',
      customSelector: {},
      bugstateOptions: [{
        id: '1',
        name: '待解决'
      }, {
        id: '2',
        name: '已确认'
      }, {
        id: '3',
        name: '研发驳回'
      }, {
        id: '5',
        name: '测试驳回'
      }, {
        id: '4',
        name: '待验证'
      }, {
        id: '6',
        name: '已解决'
      }],
      status: '',
      statusOptions: testStatus,
      priority: '',
      priorityOptions: [{
        id: '4',
        name: '紧急'
      }, {
        id: '3',
        name: '高'
      }, {
        id: '2',
        name: '中'
      }, {
        id: '1',
        name: '低'
      }],
      levelOptions: [{
        id: 'DEBUG',
        name: 'DEBUG'
      }, {
        id: 'WARN',
        name: 'WARN'
      }, {
        id: 'INFO',
        name: 'INFO'
      }, {
        id: 'ERROR',
        name: 'ERROR'
      }, {
        id: 'FATAL',
        name: 'FATAL'
      }],
      platformOptions: [{
        id: 'ios',
        name: 'iOS'
      }, {
        id: 'android',
        name: 'Android'
      }],
      tmplTypeOptions: [{
        id: '3',
        name: 'panoramic'
      }, {
        id: '2',
        name: 'playable'
      }, {
        id: '1',
        name: 'endcard'
      }],
      tmpltype: '',
      type: '',
      categoryLoading: true,
      time: '',
      searchField: this.aProp.defaultKey ? this.aProp.defaultKey : 'app_name',
      keyword: '',
      bStyleLoading: true,
      bAnimationLoading: true,
      style: '',
      animation: '',
      aModelAnimationOptions: [],
      aModelStyleOptions: [],
      pickerOptions2: {
        shortcuts: [{
          text: this.$t('form.pastWeek'),
          onClick: function onClick(picker) {
            picker.$emit('pick', [format(subDays(new Date(), 7), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')]);
          }
        }, {
          text: this.$t('form.pastMonth'),
          onClick: function onClick(picker) {
            picker.$emit('pick', [format(subDays(new Date(), 30), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')]);
          }
        }, {
          text: this.$t('form.past3Month'),
          onClick: function onClick(picker) {
            picker.$emit('pick', [format(subDays(new Date(), 90), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')]);
          }
        }]
      },

      tagConfig: {
        prop: 'tag_ids',
        params: {
          placeholder: '请选择标签'
        }
      },
      tagFormValue: {
        tag_ids: ''
      },
      demandConfig: {
        prop: 'demand_id'
      },
      demandValue: {
        demand_id: ''
      },
      config: {
        prop: 'app_cat_ids',
        width: '200px',
        params: {
          placeholder: '请选择app分类标签',
          clearable: true
        }
      },
      postData: {
        app_cat_ids: ''
      }
    };
  },

  methods: {
    handleFilter: function handleFilter() {
      if (this.fnSearch) {
        var oList = {};
        if (this.aProp.managerName) {
          oList.manager_name = this.managerName === 'All' ? '' : this.managerName;
        }
        if (this.aProp.tmplType) {
          oList.category = this.tmpltype;
        }
        if (this.aProp.platform) {
          oList.platform = this.platform;
        }
        if (this.aProp.appCategory) {
          oList.app_cat_ids = this.postData.app_cat_ids;
        }
        if (this.aProp.category) {
          oList.category = this.type;
        }
        if (this.aProp.materialOptions) {
          oList.network = this.networks;
          oList.category = this.categories;
          oList.material_type = this.genre;
          oList.tag_id = this.tags;
        }
        if (this.aProp.time && this.time) {
          oList.start_date = this.time[0];
          oList.end_date = this.time[1];
        }
        if (this.aProp.searchField) {
          oList.search_field = this.searchField;
        }
        if (this.aProp.keyword) {
          oList.keyword = this.keyword;
        }
        if (this.aProp.level) {
          oList.level = this.level;
        }
        if (this.aProp.bugstate) {
          oList.status = this.bugstate;
        }
        if (this.aProp.priority) {
          oList.priority = this.priority;
        }
        if (this.aProp.status) {
          oList.status = this.status;
        }
        if (this.aProp.bModelStyle) {
          oList.style_id = this.style;
        }
        if (this.aProp.bModelAnimation) {
          oList.type_id = this.animation;
        }
        if (this.aProp.trafficType) {
          oList.traffic_type = this.trafficType;
        }
        if (this.tagFormValue.tag_ids) {
          oList.tag_ids = this.tagFormValue.tag_ids;
        }
        if (this.demandValue.demand_id) {
          oList.demand_id = this.demandValue.demand_id;
        }
        // 获取自定义选择框值
        if (this.aProp.customSelector) {
          for (var i in this.aProp.customSelector) {
            oList[this.aProp.customSelector[i].selectorId] = this.customSelector[this.aProp.customSelector[i].selectorId].value;
          }
        }
        this.fnSearch(oList);
      }
    },
    fnReset: function fnReset() {
      var self = this;
      this.networks = '';
      this.categories = '';
      this.genre = '';
      this.tags = '';
      this.platform = '';
      this.postData.app_cat_ids = [];
      this.type = '';
      this.keyword = '';
      this.searchField = this.aProp.defaultKey ? this.aProp.defaultKey : 'app_name';
      this.time = '';
      this.level = '';
      this.bugstate = '';
      this.priority = '';
      this.status = '';
      this.tmpltype = '';
      this.style = '';
      this.animation = '';
      this.trafficType = '';
      this.tagFormValue.tag_ids = '';
      this.demandValue.demand_id = '';
      // 重置自定义搜索选择框内容
      if (this.aProp.customSelector) {
        for (var i in this.aProp.customSelector) {
          var selectorId = this.aProp.customSelector[i].selectorId;
          this.customSelector[selectorId].value = this.aProp.customSelector[i].multiple ? [] : '';
        }
      }
      if (this.managerNameOptions.length) {
        this.managerName = this.managerNameOptions.find(function (e) {
          return Number(e.id) === Number(self.user_id);
        }).id;
      }
      this.handleFilter();
    },
    fillDemandValue: function fillDemandValue() {
      if (this.$route.query.demand_name) {
        this.demandValue.demand_id = this.$route.query.demand_name;
      }
    }
  }
};